var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThirdCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 901,
    height: 900,
    viewBox: "0 0 901 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.522 897.777C697.7 897.777 898.078 697.4 898.078 450.221C898.078 203.042 697.7 2.66469 450.522 2.66469C203.343 2.66469 2.96548 203.042 2.96548 450.221C2.96548 697.4 203.343 897.777 450.522 897.777ZM450.522 899.748C698.789 899.748 900.048 698.488 900.048 450.221C900.048 201.954 698.789 0.694336 450.522 0.694336C202.255 0.694336 0.995117 201.954 0.995117 450.221C0.995117 698.488 202.255 899.748 450.522 899.748Z",
    fill: "#D7544F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M883.304 442.276L898.638 442.069L898.662 443.856L883.328 444.063L883.304 442.276Z",
    fill: "url(#paint0_linear_499_1650)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_499_1650",
    x1: 450.522,
    y1: 0.694336,
    x2: 450.522,
    y2: 899.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdCircle);
export default __webpack_public_path__ + "static/media/third-circle.883fc23f0086015767854301336190e3.svg";
export { ForwardRef as ReactComponent };